import React, { Component } from "react"
import Svg from "../_svgs/svg"
import * as date from "../../booking/helpers/date"
import { ItineraryContentBlockNoInformation } from "./ItineraryContentBlockNoInformation"
import { ItineraryContentBlockDoubleImage } from "./ItineraryContentBlockDoubleImage"
import { ItineraryContentBlockSingleImage } from "./ItineraryContentBlockSingleImage"
import { ItineraryContentBlockServiceNotice } from "./ItineraryContentBlockServiceNotice"
import { ItineraryContentBlockHeadlineButton } from "./ItineraryContentBlockHeadlineButton"
import { ItineraryContentBlockCarousel } from "./ItineraryContentBlockCarousel"
import { ItineraryUspContainer } from "./ItineraryUspContainer"
import { ItineraryArrivalDeparture } from "./ItineraryArrivalDeparture"
import { ItineraryBoarding } from "./ItineraryBoarding"
import { ItinerarySecurity } from "./ItinerarySecurity"
import { ItineraryPassport } from "./ItineraryPassport"
import { ItineraryCheckIn } from "./ItineraryCheckIn"
import { ItinerarySection } from "./ItinerarySection"
import { ItineraryCriticalInformation } from "./ItineraryCriticalInformation"
import { ItineraryParking } from "./ItineraryParking"
import { ItineraryTaxfree } from "./ItineraryTaxfree"
import { ItineraryArrivalAtAirport } from "./ItineraryArrivalAtAirport"
import { UspBannerBlock } from "./UspBannerBlock"
import { ItineraryTravelInformation } from "./ItineraryTravelInformation"
import { ItineraryEssentialInfo } from "./ItineraryEssentialInfo"
import { ItineraryBaggage } from "./ItineraryBaggage"
import { ItineraryObsBlock } from "./ItineraryObsBlock"
import { ItineraryDepartureList } from "./ItineraryDepartureList"
import * as endpoint from "../../booking/constants/Endpoints"
import axios from "axios"
import { hosts } from "./itinerary-module"
import * as cookieNames from "../../booking/constants/Cookies"
import * as cookieHelper from "../../helpers/cookie"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import reactStringReplace from "react-string-replace"
import Emitter from "../../helpers/emitter"
import * as emits from "../../constants/emits"
import * as TravelTypes from "./TravelTypes"
import { isMobile } from "react-device-detect"
import { DateTime } from "luxon"
import { trackTravelPlanner } from "../../helpers/tracking"
import MerchantInfoModal from "../modal/merchant-info-modal"

export class ItineraryComponent extends Component {
  constructor(props) {
    super(props)

    const currentPageJson = props.currentPage && JSON.parse(props.currentPage)
    const fingerJson = props.finger && JSON.parse(props.finger)
    const gateJson = props.gate && JSON.parse(props.gate)
    const flightInfo = props.flightInfo && JSON.parse(props.flightInfo)
    const travelInformationData = props.travelInformationData && JSON.parse(props.travelInformationData)

    this.state = {
      flightInfo: flightInfo,
      time: props.time,
      terminalLabel: props.terminalLabel,
      gateLabel: props.gateLabel,
      statusLabel: props.statusLabel,
      changeLinkString: props.changeLinkString,
      flightIdLink: props.flightIdLink,
      currentPageJson: currentPageJson,
      airlinesPageLink: props.airlinesPage,
      finger: fingerJson,
      gate: gateJson,
      checkInOpens: props.checkInOpens,
      gateCloses: props.gateCloses,
      boardingOpens: props.boardingOpens,
      awaitingClosedLabel:
        flightInfo?.PublicRollOff === "1" ? currentPageJson?.closedLabel || "Closed" : currentPageJson?.awaitingLabel || "Afventer",
      closedLabel: currentPageJson?.closedLabel || "Closed",
      awaitingLabel: currentPageJson?.awaitingLabel || "Afventer",
      profile: props.profile,
      isLoggedIn: props.profile && props.profile !== {} ? true : false,
      travelInformation: undefined,
      parkingStructureDataAltitude: undefined,
      parkingStructureDataCrm: undefined,
      parkingStructureDataCrmIdp: undefined,
      followFlight: false,
      statusClass: flightInfo?.statusClass || "",
      publicRemark: flightInfo?.status || "",
      tabToggle: flightInfo.Direction === "D" ? TravelTypes.DEPARTURE : TravelTypes.ARRIVAL,
      earlierStepsOpen: false,
      travelInformationData: travelInformationData || {},
      updatedTime: DateTime.now(),
      isMerchantModalShown: false,
      showMerchantInfoModal: this.showMerchantInfoModal,
    }

    this.handleClickTracking = this.props.handleClickTracking.bind(this)

    this.cancelledRef = React.createRef()
  }

  componentDidMount() {
    let followFlightCookie = cookieHelper.getCookie(cookieNames.CPH_FOLLOW_FLIGHT)
    if (followFlightCookie) {
      const flightFollowed = followFlightCookie.filter((f) => f.id === this.state.flightInfo.FlightId).length > 0
      this.setState({ followFlight: flightFollowed })
    }

    const destinationHeader = document.getElementsByClassName("destination-header__text")[0]
    this.topOffset = destinationHeader && destinationHeader.getBoundingClientRect().top + window.scrollY

    var hash = window.location.hash
    if (hash) {
      if (hash === "#cancelled") {
        this.cancelledRef.current.scrollIntoView({
          behavior: "smooth",
        })
      }
    }

    if (this.state.profile && this.state.profile !== {} && this.state.isLoggedIn) {
      this.setLoginState()
    }

    this.setState({ ...this.getSteps() })
    this.addEventListeners()
    this.initiateAutomaticFlightInfoUpdate()
  }

  componentDidUpdate() {
    if (this.state.profile !== this.props.profile) {
      this.setState({ profile: this.props.profile }, () => {
        this.setLoginState()
      })
    }
    this.addEventListeners()
  }

  initiateAutomaticFlightInfoUpdate = () => {
    const now = new Date()
    const seconds = now.getSeconds()
    const msTimeout = (60 - seconds) * 1000 // amount of seconds until 0 seconds on the clock. Used to sync the two places we're updating flightinfo every minute
    setTimeout(() => {
      this.updateFlightInfoAndSteps()
      setInterval(() => {
        this.updateFlightInfoAndSteps()
      }, 60000) // refresh flightInfo and steps every minute
    }, msTimeout)
  }

  addEventListeners() {
    const anchorLinks = document.querySelectorAll('a[href="#timatic-anchor"]')
    const accordion = document.querySelector("#timatic-anchor")
    if (accordion) {
      const accordionHeadline = accordion.querySelector("h5")
      if (anchorLinks.length > 0 && accordionHeadline) {
        anchorLinks.forEach((element) => {
          element.addEventListener("click", () => {
            if (!accordion.classList.contains("open")) {
              this.eventFire(accordionHeadline, "click")
            }
          })
        })
      }
    }

    var followFlightInput = document.getElementById("followFlight")
    if (followFlightInput) {
      followFlightInput.addEventListener("change", (e) => {
        if (e.target) {
          let slider = document.getElementsByClassName("followFlightReact")
          if (slider && slider[0].dataset.enableFollowFlight === "true") {
            if (e.target.checked) {
              this.setState({ followFlight: true })
              this.showSignupModal("toggle")
            } else {
              this.setState({ followFlight: false })
            }
          }
        }
      })
    }
  }

  showMerchantInfoModal = (MerchantSlideObject) => {
    if (!MerchantSlideObject) return

    this.setState(
      (prevState) => ({
        merchantModalData: MerchantSlideObject,
        isMerchantModalShown: !prevState.isMerchantModalShown,
      }),
      () => {
        // Update body scrolling based on modal state
        if (this.state.isMerchantModalShown) {
          document.body.classList.add("body-lock-scroll")
        } else {
          document.body.classList.remove("body-lock-scroll")
        }
      },
    )
  }

  updateFlightInfoAndSteps = async () => {
    const response = await axios.get(endpoint.FLIGHT_INFO_SOLR(hosts, this.state.flightInfo.language, this.state.flightInfo.RecordId))
    if (response && response.data) {
      const flight = JSON.parse(response.data)
      const now = DateTime.now()
      console.log(now)
      this.setState({ flightInfo: flight, statusClass: flight.statusClass, publicRemark: flight.status, updatedTime: now }, () => {
        this.setState({ ...this.getSteps() })
      })
    }
  }

  getSteps() {
    let tabOneActiveSteps = []
    let tabOneInactiveSteps = []
    let tabTwoActiveSteps = []
    let tabTwoInactiveSteps = []
    if (this.state.flightInfo.Direction === "D") {
      tabOneActiveSteps = this.removeEmptiesFromArray(this.getContentSections(this.state.currentPageJson.itineraryContentAreaDeparture, false))
      tabOneInactiveSteps = this.removeEmptiesFromArray(this.getContentSections(this.state.currentPageJson.itineraryContentAreaDeparture, true))
      tabTwoActiveSteps = this.removeEmptiesFromArray(
        this.getContentSections(this.state.currentPageJson.itineraryContentAreaDepartureTransferTab, false),
      )
      tabTwoInactiveSteps = this.removeEmptiesFromArray(
        this.getContentSections(this.state.currentPageJson.itineraryContentAreaDepartureTransferTab, true),
      )
    } else {
      tabOneActiveSteps = this.removeEmptiesFromArray(this.getContentSections(this.state.currentPageJson.itineraryContentAreaArrival, false))
      tabOneInactiveSteps = this.removeEmptiesFromArray(this.getContentSections(this.state.currentPageJson.itineraryContentAreaArrival, true))
      tabTwoActiveSteps = this.removeEmptiesFromArray(this.getContentSections(this.state.currentPageJson.itineraryContentAreaArrivalPickupTab, false))
      tabTwoInactiveSteps = this.removeEmptiesFromArray(
        this.getContentSections(this.state.currentPageJson.itineraryContentAreaArrivalPickupTab, true),
      )
    }
    return { tabOneActiveSteps, tabOneInactiveSteps, tabTwoActiveSteps, tabTwoInactiveSteps }
  }

  setLoginState = () => {
    const cookieToken = cookieHelper.getCookie(cookieNames.ACCESS_TOKEN)
    const currentToken = window.localStorage.myAuthToken
    if (!cookieToken) {
      if (currentToken) {
        // session timed out or logout was forced
        delete window.localStorage.myAuthToken
        delete axios.defaults.headers.common["Authorization"]
        this.setState({ travelInformation: undefined })
      }
    } else if (
      cookieToken !== currentToken ||
      !this.state.travelInformation ||
      !this.state.parkingStructureDataAltitude ||
      !this.state.parkingStructureDataCrm ||
      !this.state.parkingStructureDataCrmIdp
    ) {
      // new token arrived or state is not loaded
      window.localStorage.myAuthToken = cookieToken
      axios.defaults.headers.common["Authorization"] = "Bearer " + cookieToken
      this.getTravelInformation()

      // only placed here for testing purposes
      // this.getParkingStructureDataAltitude()
      // this.getParkingStructureDataCrm()
      // this.getParkingStructureDataCrmIdp()
    }
  }

  getTravelInformation = () => {
    var getParams = {
      flightDisplayName: this.state.flightInfo.Flight,
      direction: this.state.flightInfo.Direction,
      scheduledDate: this.state.flightInfo.ScheduledTime,
    }
    axios
      .get(endpoint.GET_TRAVEL_INFORMATION(hosts), { params: getParams })
      .then((res) => res.data)
      .then(
        (result) => {
          this.setState({
            travelInformation: result,
          })
        },
        (error) => {
          this.setState({
            error,
          })
        },
      )
  }

  getParkingStructureDataAltitude = () => {
    axios
      .get(endpoint.MOST_BOOKED_STRUCTURE_ALTITUDE(hosts, this.state.flightInfo.language))
      .then((res) => res.data)
      .then(
        (result) => {
          this.setState({
            parkingStructureDataAltitude: result,
          })
        },
        (error) => {
          this.setState({
            error,
          })
        },
      )
  }

  getParkingStructureDataCrm = () => {
    axios
      .get(endpoint.MOST_BOOKED_STRUCTURE_CRM(hosts, this.state.flightInfo.language))
      .then((res) => res.data)
      .then(
        (result) => {
          this.setState({
            parkingStructureDataCrm: result,
          })
        },
        (error) => {
          this.setState({
            error,
          })
        },
      )
  }

  getParkingStructureDataCrmIdp = () => {
    axios
      .get(endpoint.MOST_BOOKED_STRUCTURE_CRM_IDP(hosts, this.state.flightInfo.language))
      .then((res) => res.data)
      .then(
        (result) => {
          this.setState({
            parkingStructureDataCrm: result,
          })
        },
        (error) => {
          this.setState({
            error,
          })
        },
      )
  }

  renderFlightInfoBottomBlock(contentArea) {
    return contentArea
      ? contentArea.map((block, i) => {
          switch (block.__type__) {
            case "FlightInfoBottomBlock": {
              const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(block.buttonIcon)
              return (
                <React.Fragment key={i}>
                  <div className="departure-info__essentials__bottom">
                    <h5>{block.text}</h5>
                    <div>
                      <a
                        className="button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default"
                        href={block.linkToAirport ? this.state.changeLinkString : this.state.flightIdLink}
                        onClick={() => this.handleClickTracking(block.buttonTracking)}
                      >
                        {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                        <span className="text">{block.buttonText}</span>
                      </a>
                    </div>
                  </div>
                </React.Fragment>
              )
            }
          }
        })
      : null
  }

  renderItineraryInfoBlocks(contentArea) {
    return contentArea
      ? contentArea.map((block, i) => {
          switch (block.__type__) {
            case "UspBannerBlock":
              return <UspBannerBlock key={i} showHideContent={this.showHideContent} block={block} />
            case "ItineraryCriticalInformation":
              return <ItineraryCriticalInformation key={i} block={block} handleClickTracking={this.handleClickTracking} />
            case "ItineraryEssentialInfo":
              return <ItineraryEssentialInfo key={i} {...this.state} block={block} showHideContent={this.showHideContent} />
            case "ItineraryTravelInformationBlock":
              return (
                <ItineraryTravelInformation
                  key={i}
                  {...this.state}
                  block={block}
                  showHideContent={this.showHideContent}
                  setDataToState={this.setDataToState}
                />
              )
          }
        })
      : null
  }

  getSelectionCondition = (choice, blockCondition) => {
    return (
      (choice === undefined && (blockCondition === undefined || blockCondition === "" || blockCondition === "default")) || choice === blockCondition
    )
  }

  exactSelectionCondition = (choice, blockCondition) => {
    // If the block matches on a specific value, the value must match the selection
    return blockCondition === undefined || blockCondition === "" || blockCondition === "default" || choice === blockCondition
  }

  getBlockToRender = (travelInformation, blocks) => {
    let defaultBlock = undefined
    let bestCriteriaMatchCount = 0

    let hasLuggage = travelInformation.twl ?? undefined
    let hasKids = travelInformation.twc ?? undefined
    let transportForm = travelInformation.tf ?? undefined

    for (let i = 0; i < blocks.length; i++) {
      let block = blocks[i]
      let blockHasLuggage = SelectionFactoryHelper.getFromSelectionFactory(block.checkingInBaggage)
      blockHasLuggage = blockHasLuggage === "true" ? true : blockHasLuggage === "false" ? false : blockHasLuggage
      let blockHasKids = SelectionFactoryHelper.getFromSelectionFactory(block.travelingWithKids)
      blockHasKids = blockHasKids === "true" ? true : blockHasKids === "false" ? false : blockHasKids
      let blockTransportForm = SelectionFactoryHelper.getFromSelectionFactory(block.transportToAirport)
      blockTransportForm = blockTransportForm === "true" ? true : blockTransportForm === "false" ? false : blockTransportForm

      if (blockTransportForm === "Private car (or motorcycle scooter)") {
        blockTransportForm = "Private car (or motorcycle, scooter)"
      }

      // Check exact match requirement
      if (!this.exactSelectionCondition(hasLuggage, blockHasLuggage)) {
        continue
      }
      if (!this.exactSelectionCondition(hasKids, blockHasKids)) {
        continue
      }
      if (!this.exactSelectionCondition(transportForm, blockTransportForm)) {
        continue
      }

      // Check best match
      let luggageCondition = this.getSelectionCondition(hasLuggage, blockHasLuggage)
      let kidsCondition = this.getSelectionCondition(hasKids, blockHasKids)
      let transportCondition = this.getSelectionCondition(transportForm, blockTransportForm)

      let criteriaMatchCount = luggageCondition + kidsCondition + transportCondition
      if (criteriaMatchCount > bestCriteriaMatchCount) {
        bestCriteriaMatchCount = criteriaMatchCount
        defaultBlock = block
      }

      // If there was a perfect match we look no further
      if (luggageCondition && kidsCondition && transportCondition) {
        defaultBlock = block
        break
      }

      if (!defaultBlock && blockHasKids === "default" && blockHasLuggage === "default" && blockTransportForm === "default") {
        defaultBlock = block
      }
    }

    return defaultBlock
  }

  getContentSections(contentArea, renderInactive = false) {
    let sections = []

    const dtLocale = date.luxonLocale(this.state.flightInfo.language)
    const zone = "Europe/Copenhagen"
    const currentTime = DateTime.local().setLocale(dtLocale).setZone(zone)
    const estimatedPublicTime = DateTime.fromISO(this.state.flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)

    if (this.state.flightInfo.Direction === "D") {
      const checkInTime = estimatedPublicTime.minus({ minutes: this.state.checkInOpens })
      const checkInActive = checkInTime <= currentTime

      const boardingTime = estimatedPublicTime.minus({ minutes: this.state.boardingOpens })
      const boardingActive = boardingTime <= currentTime

      const arrDepActive = estimatedPublicTime <= currentTime

      let beforeCheckInSection = true
      let beforeBoardingSection = true
      let beforeArrDepSection = true

      let condition = true
      let render = ""

      let groups = contentArea ? this.groupBy(contentArea) : null

      sections = groups
        ? groups.map((blocks, i) => {
            let inactive = false

            let block = this.getBlockToRender(this.state.travelInformationData, blocks)
            if (!block) {
              return
            }
            switch (block.__type__) {
              case "ItinerarySectionBlock":
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  this.state.flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItinerarySection
                    key={i}
                    {...this.state}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    showSignupModal={this.showSignupModal}
                    block={block}
                    flightInfo={this.state.flightInfo}
                    airlinesPageLink={this.state.airlinesPageLink}
                    handleClickTracking={this.handleClickTracking}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockArrivalAtAirport":
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  this.state.flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryArrivalAtAirport
                    key={i}
                    {...this.state}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    showSignupModal={this.showSignupModal}
                    block={block}
                    flightInfo={this.state.flightInfo}
                    airlinesPageLink={this.state.airlinesPageLink}
                    handleClickTracking={this.handleClickTracking}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockParking":
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  this.state.flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = ((inactive && renderInactive) || (!inactive && !renderInactive)) && this.state.isLoggedIn
                render = condition ? (
                  <ItineraryParking
                    key={i}
                    {...this.state}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    showSignupModal={this.showSignupModal}
                    block={block}
                    flightInfo={this.state.flightInfo}
                    airlinesPageLink={this.state.airlinesPageLink}
                    handleClickTracking={this.handleClickTracking}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockCheckIn":
                beforeCheckInSection = false
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  this.state.flightInfo.Cancelled
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryCheckIn
                    key={i}
                    {...this.state}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    showSignupModal={this.showSignupModal}
                    block={block}
                    flightInfo={this.state.flightInfo}
                    airlinesPageLink={this.state.airlinesPageLink}
                    awaitingClosedLabel={this.state.awaitingClosedLabel}
                    checkInActive={checkInActive}
                    boardingActive={boardingActive}
                    arrDepActive={arrDepActive}
                    beforeCheckInSection={beforeCheckInSection}
                    beforeBoardingSection={beforeBoardingSection}
                    beforeArrDepSection={beforeArrDepSection}
                    handleClickTracking={this.handleClickTracking}
                    checkInOpens={this.state.checkInOpens}
                    hidePastSteps={this.state.currentPageJson.hidePastSteps}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockSecurity":
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  this.state.flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItinerarySecurity
                    key={i}
                    {...this.state}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    showSignupModal={this.showSignupModal}
                    block={block}
                    flightInfo={this.state.flightInfo}
                    gate={this.state.gate}
                    airlinesPageLink={this.state.airlinesPageLink}
                    checkInActive={checkInActive}
                    boardingActive={boardingActive}
                    arrDepActive={arrDepActive}
                    beforeCheckInSection={beforeCheckInSection}
                    beforeBoardingSection={beforeBoardingSection}
                    beforeArrDepSection={beforeArrDepSection}
                    handleClickTracking={this.handleClickTracking}
                    hidePastSteps={this.state.currentPageJson.hidePastSteps}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockTaxfree":
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  this.state.flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = ((inactive && renderInactive) || (!inactive && !renderInactive)) && this.state.isLoggedIn
                render = condition ? (
                  <ItineraryTaxfree
                    key={i}
                    {...this.state}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    showSignupModal={this.showSignupModal}
                    block={block}
                    flightInfo={this.state.flightInfo}
                    airlinesPageLink={this.state.airlinesPageLink}
                    checkInActive={checkInActive}
                    boardingActive={boardingActive}
                    arrDepActive={arrDepActive}
                    beforeCheckInSection={beforeCheckInSection}
                    beforeBoardingSection={beforeBoardingSection}
                    beforeArrDepSection={beforeArrDepSection}
                    handleClickTracking={this.handleClickTracking}
                    hidePastSteps={this.state.currentPageJson.hidePastSteps}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockPassport":
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  this.state.flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryPassport
                    key={i}
                    {...this.state}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    showSignupModal={this.showSignupModal}
                    block={block}
                    flightInfo={this.state.flightInfo}
                    gate={this.state.gate}
                    airlinesPageLink={this.state.airlinesPageLink}
                    checkInActive={checkInActive}
                    boardingActive={boardingActive}
                    arrDepActive={arrDepActive}
                    beforeCheckInSection={beforeCheckInSection}
                    beforeBoardingSection={beforeBoardingSection}
                    beforeArrDepSection={beforeArrDepSection}
                    handleClickTracking={this.handleClickTracking}
                    hidePastSteps={this.state.currentPageJson.hidePastSteps}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockBoarding":
                beforeBoardingSection = false
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  this.state.flightInfo.Cancelled
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryBoarding
                    key={i}
                    {...this.state}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    showSignupModal={this.showSignupModal}
                    block={block}
                    flightInfo={this.state.flightInfo}
                    airlinesPageLink={this.state.airlinesPageLink}
                    awaitingClosedLabel={this.state.awaitingClosedLabel}
                    checkInActive={checkInActive}
                    boardingActive={boardingActive}
                    arrDepActive={arrDepActive}
                    beforeCheckInSection={beforeCheckInSection}
                    beforeBoardingSection={beforeBoardingSection}
                    beforeArrDepSection={beforeArrDepSection}
                    gate={this.state.gate}
                    handleClickTracking={this.handleClickTracking}
                    boardingOpens={this.state.boardingOpens}
                    gateCloses={this.state.gateCloses}
                    hidePastSteps={this.state.currentPageJson.hidePastSteps}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockArrivalDeparture":
                beforeArrDepSection = false
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  this.state.flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryArrivalDeparture
                    key={i}
                    {...this.state}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    showSignupModal={this.showSignupModal}
                    block={block}
                    flightInfo={this.state.flightInfo}
                    airlinesPageLink={this.state.airlinesPageLink}
                    awaitingClosedLabel={this.state.awaitingClosedLabel}
                    checkInActive={checkInActive}
                    boardingActive={boardingActive}
                    arrDepActive={arrDepActive}
                    beforeCheckInSection={beforeCheckInSection}
                    beforeBoardingSection={beforeBoardingSection}
                    beforeArrDepSection={beforeArrDepSection}
                    handleClickTracking={this.handleClickTracking}
                    hidePastSteps={this.state.currentPageJson.hidePastSteps}
                  />
                ) : (
                  ""
                )
                break
              default:
                render = ""
                break
            }
            return render
          })
        : null

      return sections
    } else {
      const lastBag = DateTime.fromISO(this.state.flightInfo.LastBag).setLocale(dtLocale).setZone(zone)
      const baggageTime = lastBag.plus({ days: 1 })
      const baggageOver = this.state.flightInfo.PublicRollOff === "1" || baggageTime <= currentTime
      let beforeBaggage = true

      let condition = true
      let render = ""

      let groups = contentArea ? this.groupBy(contentArea) : null

      sections = groups
        ? groups.map((blocks, i) => {
            let inactive = false

            let block = this.getBlockToRender(this.state.travelInformationData, blocks)
            if (!block) {
              return
            }

            switch (block.__type__) {
              case "ItineraryContentBlockArrivalDeparture":
                inactive =
                  this.state.publicRemark === "Landed" ||
                  this.state.flightInfo.Cancelled ||
                  this.state.publicRemark === "Baggage" ||
                  baggageOver === true
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryArrivalDeparture
                    key={i}
                    {...this.state}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    showSignupModal={this.showSignupModal}
                    block={block}
                    flightInfo={this.state.flightInfo}
                    airlinesPageLink={this.state.airlinesPageLink}
                    awaitingClosedLabel={this.state.awaitingClosedLabel}
                    handleClickTracking={this.handleClickTracking}
                  />
                ) : (
                  ""
                )
                break
              case "ItinerarySectionBlock":
                inactive =
                  this.state.flightInfo.Cancelled || (beforeBaggage === true && this.state.publicRemark === "Baggage") || baggageOver === true
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItinerarySection
                    key={i}
                    {...this.state}
                    showMerchantInfoModal={this.state.showMerchantInfoModal}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    block={block}
                    showSignupModal={this.showSignupModal}
                    flightInfo={this.state.flightInfo}
                    airlinesPageLink={this.state.airlinesPageLink}
                    handleClickTracking={this.handleClickTracking}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockBaggage":
                inactive = this.state.flightInfo.Cancelled || baggageOver === true
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                beforeBaggage = false
                render = condition ? (
                  <ItineraryBaggage
                    key={i}
                    {...this.state}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    block={block}
                    showSignupModal={this.showSignupModal}
                    flightInfo={this.state.flightInfo}
                    airlinesPageLink={this.state.airlinesPageLink}
                    handleClickTracking={this.handleClickTracking}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockSecurity":
                inactive = this.state.flightInfo.Cancelled || baggageOver === true
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryPassport
                    key={i}
                    {...this.state}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    block={block}
                    showSignupModal={this.showSignupModal}
                    flightInfo={this.state.flightInfo}
                    airlinesPageLink={this.state.airlinesPageLink}
                    handleClickTracking={this.handleClickTracking}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockDepartureList":
                inactive = this.state.flightInfo.Cancelled
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryDepartureList
                    key={i}
                    {...this.state}
                    renderContentBlocks={this.renderContentBlocks}
                    showHideContent={this.showHideContent}
                    block={block}
                    showSignupModal={this.showSignupModal}
                    flightInfo={this.state.flightInfo}
                    airlinesPageLink={this.state.airlinesPageLink}
                    handleClickTracking={this.handleClickTracking}
                  />
                ) : (
                  ""
                )
                break
              default:
                render = ""
                break
            }
            return render
          })
        : null
      return sections
    }
  }

  renderContentBlocks(contentArea, showNoInformationBox = true) {
    const dtLocale = date.luxonLocale(this.state.flightInfo.language)
    const zone = "Europe/Copenhagen"
    const estimatedPublicTime = DateTime.fromISO(this.state.flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)
    return contentArea
      ? contentArea.map((block, i) => {
          switch (block.__type__) {
            case "ItineraryContentBlockHeadlineButton":
              return (
                <ItineraryContentBlockHeadlineButton
                  key={i}
                  block={block}
                  handleClickTracking={this.handleClickTracking}
                  showSignupModal={this.showSignupModal}
                />
              )
            case "ItineraryContentBlockSingleImage":
              return (
                <ItineraryContentBlockSingleImage
                  key={i}
                  block={block}
                  flightInfo={this.state.flightInfo}
                  showSignupModal={this.showSignupModal}
                  tabToggle={this.props.tabToggle}
                />
              )
            case "ItineraryContentBlockDoubleImage":
              return (
                <ItineraryContentBlockDoubleImage
                  key={i}
                  block={block}
                  handleClickTracking={this.handleClickTracking}
                  showSignupModal={this.showSignupModal}
                />
              )
            case "ItineraryContentBlockNoInformation":
              return showNoInformationBox ? (
                <ItineraryContentBlockNoInformation
                  key={i}
                  block={block}
                  handleClickTracking={this.handleClickTracking}
                  showSignupModal={this.showSignupModal}
                />
              ) : (
                ""
              )
            case "ItineraryObsBlock":
              return (
                <ItineraryObsBlock
                  key={i}
                  block={block}
                  handleClickTracking={this.handleClickTracking}
                  showSignupModal={this.showSignupModal}
                  showHideContent={this.showHideContent}
                />
              )
            case "ItineraryUspContainerBlock":
              return <ItineraryUspContainer key={i} block={block} />
            case "ItineraryContentBlockCarousel":
              return (
                <ItineraryContentBlockCarousel
                  key={i}
                  language={this.state.flightInfo.language}
                  showMerchantInfoModal={this.state.showMerchantInfoModal}
                  block={block}
                  flightInfo={this.state.flightInfo}
                  tabToggle={this.props.tabToggle}
                  estimatedPublicTime={estimatedPublicTime}
                />
              )
            case "ItineraryContentBlockServiceNotice":
              return (
                <ItineraryContentBlockServiceNotice
                  key={i}
                  block={block}
                  flightInfo={this.state.flightInfo}
                  showSignupModal={this.showSignupModal}
                  tabToggle={this.props.tabToggle}
                />
              )
            default:
              return null
          }
        })
      : null
  }

  showHideContent(event, classname, steps = false) {
    const sel = getSelection().toString()
    if (!sel) {
      let elem = event.currentTarget.parentElement
      elem.__toggle = !elem.__toggle
      let target = elem.querySelector(classname)
      let parentAccordion = elem.closest(classname)
      if (elem.__toggle) {
        target.style.height = target.scrollHeight + "px"
        elem.classList.add("open")
        if (parentAccordion) {
          const parentHeight = parentAccordion.offsetHeight
          const combinedHeight = parentHeight + target.scrollHeight
          parentAccordion.style.height = combinedHeight + "px"
        }
      } else {
        if (parentAccordion) {
          const parentHeight = parentAccordion.offsetHeight
          const reducedHeight = parentHeight - target.scrollHeight
          parentAccordion.style.height = reducedHeight + "px"
        }
        target.style.height = 0 + "px"
        elem.classList.remove("open")
      }
      if (steps) {
        this.setState(
          (prevState) => ({
            earlierStepsOpen: !prevState.earlierStepsOpen,
          }),
          () => {
            if (this.state.earlierStepsOpen) {
              // expand
              trackTravelPlanner("track-event.generic", "previous steps - expand", "", this.state.flightInfo.FlightId)
            } else {
              // collapse
              trackTravelPlanner("track-event.generic", "previous steps - collapse", "", this.state.flightInfo.FlightId)
            }
          },
        )
      }
    }
  }

  tabToggle = (type) => {
    this.setState({ tabToggle: type, earlierStepsOpen: false }, () => {
      this.handleTabChangeTracking(type)
      this.setState({ ...this.getSteps() })
      let foldables = document.querySelectorAll(".foldable")
      if (foldables && foldables.length > 0) {
        foldables.forEach((element) => {
          let contentWrapper = element.querySelector(".contentWrapper")
          if (contentWrapper) {
            contentWrapper.style.height = null
          }
          element.__toggle = false
          element.classList.remove("open")
        })
      }
    })
  }

  removeEmptiesFromArray = (array) => {
    if (array && array.length > 0) {
      return array.filter((e) => {
        return e
      })
    }
    return array
  }

  showSignupModal = (trackingEventLabel = "") => {
    Emitter.emit("*", {
      type: emits.REQUEST_FLIGHT_SIGNUP_MODAL,
      modalJson: {
        textKeys: this.state.currentPageJson,
        flightInfo: this.state.flightInfo,
        profile: this.state.profile,
        travelType: this.state.tabToggle,
        travelInformation: this.state.travelInformationData,
        trackingEventLabel: trackingEventLabel,
        source: "itinerary",
        language: this.state.flightInfo.language,
      },
    })
  }

  setDataToState = (data, updateSteps = false) => {
    this.setState(data, () => {
      if (updateSteps) {
        this.setState({ ...this.getSteps() })
      }
    })
  }

  groupBy = (array) => {
    let group = []
    let currentType = undefined
    let currentGroup = undefined
    for (var i = 0; i < array.length; i++) {
      if (currentType !== array[i].__type__) {
        if (currentGroup) {
          group.push(currentGroup)
        }
        currentType = array[i].__type__
        currentGroup = [array[i]]
      } else {
        currentGroup.push(array[i])
      }
    }
    if (currentGroup) {
      group.push(currentGroup)
    }
    return group
  }

  eventFire(el, etype) {
    if (el.fireEvent) {
      el.fireEvent("on" + etype)
    } else {
      var evObj = document.createEvent("Events")
      evObj.initEvent(etype, true, false)
      el.dispatchEvent(evObj)
    }
  }

  handleTabChangeTracking = (type) => {
    switch (type) {
      case TravelTypes.DEPARTURE:
        trackTravelPlanner("track-event.generic", "tab click", "departure", this.state.flightInfo.FlightId)
        break
      case TravelTypes.ARRIVAL:
        trackTravelPlanner("track-event.generic", "tab click", "arrival", this.state.flightInfo.FlightId)
        break
      case TravelTypes.TRANSFER:
        trackTravelPlanner("track-event.generic", "tab click", "transfer", this.state.flightInfo.FlightId)
        break
      case TravelTypes.PICKUP:
        trackTravelPlanner("track-event.generic", "tab click", "pick-up", this.state.flightInfo.FlightId)
        break
      default:
        break
    }
  }

  render() {
    const tabOne = this.state.flightInfo.Direction === "D" ? TravelTypes.DEPARTURE : TravelTypes.ARRIVAL
    const tabOneLabel =
      this.state.flightInfo.Direction === "D"
        ? this.state.currentPageJson.destinationTabLabel || "Destination"
        : this.state.currentPageJson.arrivalTabLabel || "Ankomst"
    const tabTwo = this.state.flightInfo.Direction === "D" ? TravelTypes.TRANSFER : TravelTypes.PICKUP
    const tabTwoLabel =
      this.state.flightInfo.Direction === "D"
        ? this.state.currentPageJson.transferTabLabel || "Transfer"
        : this.state.currentPageJson.pickupTabLabel || "Afhent"

    let inactiveSteps = []
    let activeSteps = []
    if (this.state.tabToggle === tabOne) {
      activeSteps = this.state.tabOneActiveSteps
      inactiveSteps = this.state.tabOneInactiveSteps
    } else {
      activeSteps = this.state.tabTwoActiveSteps
      inactiveSteps = this.state.tabTwoInactiveSteps
    }
    if (this.state.tabToggle === TravelTypes.TRANSFER || this.state.tabToggle === TravelTypes.PICKUP) {
      activeSteps = inactiveSteps.concat(activeSteps)
      inactiveSteps = []
    }

    const dtLocale = date.luxonLocale(this.state.flightInfo.language)
    const zone = "Europe/Copenhagen"
    const currentTime = DateTime.local().setLocale(dtLocale).setZone(zone)
    const estimatedPublicTime = DateTime.fromISO(this.state.flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)
    const scheduledTime = DateTime.fromISO(this.state.flightInfo.ScheduledTime).setLocale(dtLocale).setZone(zone)

    let enableFollowFlight =
      (this.state.flightInfo.Direction === "A" && this.state.currentPageJson.enableFollowFlightArrivals) ||
      (this.state.flightInfo.Direction === "D" && this.state.currentPageJson.enableFollowFlight)
    enableFollowFlight = this.state.tabToggle === TravelTypes.TRANSFER ? false : enableFollowFlight
    enableFollowFlight = currentTime < estimatedPublicTime ? enableFollowFlight : false
    const signUpLabel =
      this.state.currentPageJson.signUpHereFlightinformation || "Skal vi sende dig opdateringer om din afrejse? {Tilmeld din afgang her}"
    let flightinformationSignupLink = reactStringReplace(signUpLabel, /\{([^}]+)\}/g, (match, i) => (
      <a
        key={i}
        className={"pointer"}
        onClick={() => {
          this.showSignupModal("toggle")
          trackTravelPlanner("track-event.generic", "follow flight - click", "toggle - content", this.state.flightInfo.FlightId)
        }}
      >
        {match.replace(/\{|\}/gi, "")}
      </a>
    ))
    flightinformationSignupLink = enableFollowFlight ? flightinformationSignupLink : ""

    const {
      flightInfoBottomContentAreaDeparture,
      itineraryInfoContentAreaDeparture,
      itineraryTravelInformationContentAreaDeparture,
      flightInfoBottomContentAreaArrival,
      itineraryInfoContentAreaArrival,
      itineraryTravelInformationContentAreaArrival,
    } = this.state.currentPageJson

    let noHeaderBottomMargin = false
    if (this.state.flightInfo.Direction === "D") {
      noHeaderBottomMargin =
        (!flightInfoBottomContentAreaDeparture || (flightInfoBottomContentAreaDeparture && flightInfoBottomContentAreaDeparture.length === 0)) &&
        (!itineraryInfoContentAreaDeparture || (itineraryInfoContentAreaDeparture && itineraryInfoContentAreaDeparture.length === 0)) &&
        (!itineraryTravelInformationContentAreaDeparture ||
          (itineraryTravelInformationContentAreaDeparture && itineraryTravelInformationContentAreaDeparture.length === 0)) &&
        !(
          (this.state.tabTwoActiveSteps && this.state.tabTwoActiveSteps.length > 0) ||
          (this.state.tabTwoInactiveSteps && this.state.tabTwoInactiveSteps.length > 0)
        )
    } else {
      noHeaderBottomMargin =
        (!flightInfoBottomContentAreaArrival || (flightInfoBottomContentAreaArrival && flightInfoBottomContentAreaArrival.length === 0)) &&
        (!itineraryInfoContentAreaArrival || (itineraryInfoContentAreaArrival && itineraryInfoContentAreaArrival.length === 0)) &&
        (!itineraryTravelInformationContentAreaArrival ||
          (itineraryTravelInformationContentAreaArrival && itineraryTravelInformationContentAreaArrival.length === 0)) &&
        !(
          (this.state.tabTwoActiveSteps && this.state.tabTwoActiveSteps.length > 0) ||
          (this.state.tabTwoInactiveSteps && this.state.tabTwoInactiveSteps.length > 0)
        )
    }

    const hideImage = isMobile ? this.state.currentPageJson.hideAirlineImageMobile : this.state.currentPageJson.hideAirlineImage

    const updatedTime = this.state.updatedTime.setLocale(dtLocale).setZone(zone).toFormat("dd.MM.yyyy, HH:mm")

    return (
      <React.Fragment>
        {this.state.isMerchantModalShown ? (
          <MerchantInfoModal
            clickTracking={this.state.merchantModalData.clickTracking}
            tabToggle={this.state.merchantModalData.tabToggle}
            link={this.state.merchantModalData.link}
            name={this.state.merchantModalData.name}
            img={this.state.merchantModalData.img}
            categories={this.state.merchantModalData.categories}
            merchantDescription={this.state.merchantModalData.merchantDescription}
            merchantEmail={this.state.merchantModalData.merchantEmail}
            merchantNumber={this.state.merchantModalData.merchantNumber}
            merchantPhone={this.state.merchantModalData.merchantPhone}
            websiteAdress={this.state.merchantModalData.websiteAdress}
            supportsClickAndCollect={this.state.merchantModalData.supportsClickAndCollect}
            supportsHomeDelivery={this.state.merchantModalData.supportsHomeDelivery}
            homeDeliveryLabel={this.state.merchantModalData.homeDeliveryLabel}
            flightGate={this.state.flightInfo.Gate}
            merchantIsNearGate={this.state.merchantModalData.merchantIsNearGate}
            sameMerchants={this.state.merchantModalData.sameMerchants}
            nearGateSplashLabel={this.state.merchantModalData.nearGateSplashLabel}
            emailCoverLabel={this.state.merchantModalData.emailCoverLabel}
            alwaysOpen={this.state.merchantModalData.alwaysOpen}
            alwaysOpenLabel={this.state.merchantModalData.alwaysOpenLabel}
            estimatedPublicTime={this.state.merchantModalData.estimatedPublicTime}
            readMoreLabel={this.state.merchantModalData.readMoreLabel}
            readLessLabel={this.state.merchantModalData.readLessLabel}
            findAllLabel={this.state.merchantModalData.findAllLabel}
            clickAndCollectLabel={this.state.merchantModalData.clickAndCollectLabel}
            shopLocation={this.state.merchantModalData.shopLocation}
            showMerchantInfoModal={this.showMerchantInfoModal}
            isMerchantModalShown={this.state.isMerchantModalShown || false}
            lang={this.state.flightInfo.language}
            openingHours={this.state.merchantModalData.openingHours}
            openLabel={this.state.merchantModalData.openLabel}
            openingLabel={this.state.merchantModalData.openingLabel}
            closedLabel={this.state.merchantModalData.closedLabel}
            closingLabel={this.state.merchantModalData.closingLabel}
            weekdays={this.state.merchantModalData.weekdays}
            isFlightDateOlderThanToday={this.state.merchantModalData.isFlightDateOlderThanToday}
          />
        ) : null}
        <div className="heroimg">
          {!hideImage && this.props.airlineHeroImage ? <img loading="eager" fetchPriority="high" src={this.props.airlineHeroImage} /> : ""}
          <div className="heroimg__text-placeholder">
            <div className="destination-header__text__left">
              <div className={this.props.showFlightInfoBackgroundBox === "True" ? "w-background" : ""}>
                <Svg iconName={"planesingle"} fillColor={"#061143"} />
                <h6>
                  <span>{this.state.flightInfo.Flight}</span> - {this.state.flightInfo.DestinationName}
                </h6>
                <br />
                <h1>{this.state.flightInfo.DestinationName?.split("-")[0]}</h1>
                {this.state.publicRemark ? (
                  <span className="gateinfo-placeholder">
                    <div className={`gateinfo ${this.state.statusClass}`}>{this.state.publicRemark}</div>
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="w--wider">
          <div className="showondesktop">
            <div className="flight-info-update">
              <span className="label">{`${this.props.updatedLabel || "Opdateret:"} `}</span>
              <span className="time">{updatedTime}</span>
            </div>
          </div>
          <div ref={this.cancelledRef} id="itineraryTop" className="panel-simple panel-simple--departure departure-info">
            <div className="departure-info__essentials">
              <div className="departure-info__essentials__top">
                <header className={noHeaderBottomMargin ? "no-bottom-margin" : ""}>
                  <div className="showonmobile">
                    <div className="departure-info__essentials__top__content">
                      <div className="grid">
                        <div className="grid-item col--12 col-sm--6">
                          <div className="grid">
                            <div className="departure-info__essentials__top__left">
                              <h6 className="js--marquee">
                                <span className="js--marquee-inner">
                                  {this.state.flightInfo.CarrierNameMobile} - {this.state.flightInfo.Flight}
                                </span>
                              </h6>
                              <h3>
                                {this.state.time}
                                {estimatedPublicTime.toMillis() !== scheduledTime.toMillis() ? (
                                  <React.Fragment>
                                    <span className={"scheduled-time"}>{scheduledTime.toFormat("HH:mm")}</span>&ensp;
                                  </React.Fragment>
                                ) : (
                                  ""
                                )}
                                {estimatedPublicTime.toFormat("HH:mm")}
                              </h3>
                            </div>
                            <div className="departure-info__essentials__top__right">
                              <h6>{estimatedPublicTime.toFormat("yyyy")}</h6>
                              <h3>{estimatedPublicTime.toFormat("dd. LLL")}</h3>
                            </div>
                          </div>
                        </div>
                        <div className="grid-item col--12 col-sm--6">
                          <div className="grid">
                            <div className="grid-item col--6">
                              <h6 data-epi-property-name="TerminalLabel">{this.state.terminalLabel}</h6>
                              <h3>{this.state.flightInfo.CheckInTerminal || this.state.currentPageJson.terminalFallbackValue}</h3>
                            </div>
                            <div className="grid-item col--6">
                              <h6 data-epi-property-name="GateLabel">{this.state.gateLabel}</h6>
                              <h3>{this.state.flightInfo.Gate || this.state.currentPageJson.gateFallbackValue}</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="follow-flight__container__mobile">
                        <div className="follow-flight__switch__label">{this.state.currentPageJson.followFlightLabelTopComponent || "Følg fly"}</div>
                        <label
                          htmlFor="followFlight"
                          className="follow-flight__switch"
                          onClick={
                            !this.state.followFlight
                              ? () =>
                                  trackTravelPlanner(
                                    "track-event.generic",
                                    "follow flight - click",
                                    "toggle - content",
                                    this.state.flightInfo.FlightId,
                                  )
                              : undefined
                          }
                        >
                          <input type="checkbox" defaultChecked={this.state.followFlight} />
                          <span
                            className={`follow-flight__switch__slider followFlightReact ${this.state.followFlight ? "on" : "off"}`}
                            data-enable-follow-flight={enableFollowFlight}
                          ></span>
                        </label>
                        <div className="follow-flight__signup">{flightinformationSignupLink}</div>
                      </div>
                      <div className="flight-info-update">
                        <span className="label">{`${this.props.updatedLabel || "Opdateret:"} `}</span>
                        <span className="time">{updatedTime}</span>
                      </div>
                    </div>
                  </div>
                  <div className="showondesktop">
                    <div className="departure-info__essentials__top__content">
                      <div className="departure-info__essentials__top__content__cell">
                        <h6>
                          {this.state.flightInfo.Direction === "D"
                            ? this.state.currentPageJson.departureLabel || "Afgang"
                            : this.state.currentPageJson.arrivalLabel || "Ankomst"}
                        </h6>
                        <h3>
                          {this.state.time}
                          {estimatedPublicTime.toMillis() !== scheduledTime.toMillis() ? (
                            <React.Fragment>
                              <span className={"scheduled-time"}>{scheduledTime.toFormat("HH:mm")}</span>&ensp;
                            </React.Fragment>
                          ) : (
                            ""
                          )}
                          {estimatedPublicTime.toFormat("HH:mm")}
                        </h3>
                      </div>
                      <div className="departure-info__essentials__top__content__cell">
                        <h6>{this.state.currentPageJson.dateLabel || "Dato"}</h6>
                        <h3>{estimatedPublicTime.toFormat("DD")}</h3>
                      </div>
                      <div className="departure-info__essentials__top__content__cell">
                        <h6 data-epi-property-name="TerminalLabel">{this.state.terminalLabel}</h6>
                        <h3>{this.state.flightInfo.CheckInTerminal || this.state.currentPageJson.terminalFallbackValue}</h3>
                      </div>
                      <div className="departure-info__essentials__top__content__cell">
                        <h6 data-epi-property-name="GateLabel">{this.state.gateLabel}</h6>
                        <h3>{this.state.flightInfo.Gate || this.state.currentPageJson.gateFallbackValue}</h3>
                      </div>
                      <div className="departure-info__essentials__top__content__cell">
                        <a
                          className="pointer"
                          onClick={() => {
                            this.showSignupModal("toggle")
                            trackTravelPlanner("track-event.generic", "follow flight - click", "toggle - content", this.state.flightInfo.FlightId)
                          }}
                        >
                          <h6>{this.state.currentPageJson.followFlightLabelTopComponent || "Følg fly"}</h6>
                          <div className="follow-flight__text" dangerouslySetInnerHTML={{ __html: this.state.currentPageJson.getUpdatesLabel }}></div>
                        </a>
                        <label
                          htmlFor="followFlight"
                          className="follow-flight__switch"
                          onClick={
                            !this.state.followFlight
                              ? () =>
                                  trackTravelPlanner(
                                    "track-event.generic",
                                    "follow flight - click",
                                    "toggle - content",
                                    this.state.flightInfo.FlightId,
                                  )
                              : undefined
                          }
                        >
                          <input type="checkbox" defaultChecked={this.state.followFlight} />
                          <span
                            className={`follow-flight__switch__slider followFlightReact ${this.state.followFlight ? "on" : "off"}`}
                            data-enable-follow-flight={enableFollowFlight}
                          ></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
              {this.state.flightInfo.Direction === "D"
                ? this.renderFlightInfoBottomBlock(this.state.currentPageJson.flightInfoBottomBlockContentAreaDeparture)
                : this.renderFlightInfoBottomBlock(this.state.currentPageJson.flightInfoBottomBlockContentAreaArrival)}
              <div>
                {this.state.flightInfo.Direction === "D"
                  ? this.renderItineraryInfoBlocks(this.state.currentPageJson.itineraryInfoContentAreaDeparture)
                  : this.renderItineraryInfoBlocks(this.state.currentPageJson.itineraryInfoContentAreaArrival)}
              </div>

              <React.Fragment>
                {(inactiveSteps && inactiveSteps.length > 0) || (activeSteps && activeSteps.length > 0) ? (
                  (this.state.tabTwoActiveSteps && this.state.tabTwoActiveSteps.length > 0) ||
                  (this.state.tabTwoInactiveSteps && this.state.tabTwoInactiveSteps.length > 0) ? (
                    <div className="tab-panes__navigation__primary">
                      <div className="tab-panes__navigation__primary__inner w--normal">
                        <a className={`button ${this.state.tabToggle === tabOne ? "is-active" : ""}`} onClick={() => this.tabToggle(tabOne)}>
                          <span className="text">{tabOneLabel}</span>
                        </a>
                        <a className={`button ${this.state.tabToggle === tabTwo ? "is-active" : ""}`} onClick={() => this.tabToggle(tabTwo)}>
                          <span className="text">{tabTwoLabel}</span>
                        </a>
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {this.state.flightInfo.Direction === "D"
                  ? this.renderItineraryInfoBlocks(this.state.currentPageJson.itineraryTravelInformationContentAreaDeparture)
                  : this.renderItineraryInfoBlocks(this.state.currentPageJson.itineraryTravelInformationContentAreaArrival)}
                {(inactiveSteps && inactiveSteps.length > 0) || (activeSteps && activeSteps.length > 0) ? (
                  <div className="departure-info__essentials__detailitems">
                    <div className={"foldable"}>
                      {inactiveSteps && inactiveSteps.length > 0 ? (
                        <React.Fragment>
                          <h5
                            className={this.state.earlierStepsOpen ? "hide-previous-steps" : "show-previous-steps"}
                            onClick={(e) => this.showHideContent(e, ".contentWrapper", true)}
                          >
                            {this.state.earlierStepsOpen
                              ? this.state.currentPageJson?.hideEarlierStepsLabel || "Skjul tidligere trin"
                              : this.state.currentPageJson?.showEarlierStepsLabel || "Vis tidligere trin"}
                            <span className="arrow"></span>
                          </h5>
                          <div id="inactive-steps" className={`contentWrapper show-hide ${activeSteps.length === 0 ? "no-active-steps" : ""}`}>
                            {inactiveSteps}
                          </div>
                        </React.Fragment>
                      ) : (
                        ""
                      )}
                      {activeSteps && activeSteps.length > 0 ? (
                        <div
                          className={`${activeSteps.length > 0 ? "departure-info__essentials__detailitems__active" : ""} ${
                            !(inactiveSteps && inactiveSteps.length > 0) ? "no-inactive-steps" : ""
                          }`}
                        >
                          {activeSteps}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </React.Fragment>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}
